import { useQuery } from '@tanstack/react-query';
import { catalogApi } from './catalog-api.js';

// V1: genau ein Projekt pro Kunde/Instanz (NFR-7 sieht Multi-Projekt vor, aber die UI wählt bis
// dahin schlicht das erste zurückgegebene Projekt). Folge-Tasks können hier einen echten
// Projekt-Switcher nachrüsten, ohne die Aufrufer dieses Hooks anzufassen.
export function useCurrentProject() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['projects'],
    queryFn: catalogApi.listProjects,
  });
  // N5: `isError` gehört mit nach draußen. Ohne ihn ist ein fehlgeschlagenes GET /v1/projects von
  // „dieser Nutzer hat hier keine Rolle" nicht zu unterscheiden — beides endet in einer leeren
  // Rollenmenge, und die AppShell behauptete dann fälschlich, ein Administrator müsse eine Rolle
  // vergeben.
  return { project: data?.[0], isLoading, isError };
}
